export var EUserRole;
(function (EUserRole) {
    EUserRole["CLIENT"] = "CL";
    EUserRole["RM"] = "RM";
    EUserRole["PARTNER"] = "P";
})(EUserRole || (EUserRole = {}));
